var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "wscn-http404-container" }, [
    _c("div", { staticClass: "wscn-http404" }, [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "errorPage" },
        [
          _c("div", { staticClass: "errorPage__oops" }, [_vm._v("404")]),
          _vm._v(" "),
          _c("div", { staticClass: "errorPage__headline" }, [
            _vm._v(_vm._s(_vm.$t("somethingWentWrong")))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "errorPage__info" }, [
            _vm._v(_vm._s(_vm.$t("msg404")))
          ]),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function($event) {
                  return _vm.$router.push({ name: "dashboard" })
                }
              }
            },
            [
              _vm._v(
                "\n\t\t\t\t" + _vm._s(_vm.$t("backToDashboard")) + "\n\t\t\t"
              )
            ]
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "pic-404" }, [
      _c("img", {
        staticClass: "user-avatar",
        staticStyle: { width: "300px" },
        attrs: { src: require("@/assets/rslt-logo.png") }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }